import { Button, ButtonClean, Loader, Subsection } from '@fourthwall/components';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import { useDnsQuery } from '@modules/Dashboard/hooks/useDnsQuery';
import { routing } from '@utils/routing';
import React from 'react';
import { useEntri } from '../../hooks/useEntri';
import { useDeleteDomainMutation } from '../../queries/useDeleteDomainMutation';
import { useVerifyDomainMutation } from '../../queries/useVerifyDomainMutation';
import { ExistingDomainTile } from './components/ExistingDomainTile';
import * as S from './CustomDomain.styled';
const DNS_REFETCH_INTERVAL = 5_000;
export const CustomDomain = () => {
    const { currentShop } = useCurrentShop();
    const { deleteDomainMutation } = useDeleteDomainMutation();
    const { verifyDomainMutation } = useVerifyDomainMutation();
    const { dnsQuery, invalidateDnsQuery } = useDnsQuery([], {
        refetchInterval: DNS_REFETCH_INTERVAL,
    });
    const dnsList = dnsQuery.data?.dnsList;
    const { isEntriLoaded, isAutomaticSetupInProgress, isGettingProviderDetailsInProgress, connectDomain, } = useEntri({
        enabled: !!dnsList?.retryAllowed,
    });
    const isLoading = dnsQuery.isLoading;
    const handleDomainDeletion = () => {
        deleteDomainMutation.mutate(undefined, {
            onSuccess: () => {
                invalidateDnsQuery();
            },
        });
    };
    const getOnRetryConnection = () => {
        if (dnsList && dnsList.retryAllowed && isEntriLoaded) {
            return () => connectDomain(dnsList);
        }
    };
    const renderContent = () => {
        if (isLoading) {
            return (React.createElement(S.LoaderContainer, null,
                React.createElement(Loader, { size: "large" })));
        }
        if (dnsList) {
            return (React.createElement(ExistingDomainTile, { domainName: dnsList.domain, status: dnsList.status, currentShopDomain: dnsList.areAllEntriesComplete ? dnsList.domain : currentShop?.primaryDomain, shopInternalDomain: currentShop?.internalDomain, isDomainRemovalRequested: deleteDomainMutation.isLoading, isVerificationInProgress: verifyDomainMutation.isLoading, isRetryConnectionInProgress: isGettingProviderDetailsInProgress || isAutomaticSetupInProgress, onDomainDelete: handleDomainDeletion, onRetryConnection: getOnRetryConnection() }));
        }
        return (React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { appearance: "primary", label: "Connect domain", to: routing.settings.domain.create })));
    };
    return (React.createElement(Subsection, { title: "Custom domain" },
        React.createElement(S.Container, null,
            React.createElement("p", null,
                "Set a custom domain name for your site (i.e. mywebsite.com).",
                ' ',
                React.createElement(ButtonClean, { label: "Learn more", href: "https://help.fourthwall.com/hc/en-us/articles/13331283794587-How-do-I-use-a-custom-domain", target: "_blank" })),
            renderContent())));
};
